<template>
  <section class="section suggestion">
    <h1>{{ $t(brand) }}</h1>
    <div class="suggestion-text">
      <p class="text-h1">{{ $t(`suggestion_section.title.${page}`) }}</p>
      <p v-if="isStatistics && statistics" class="suggestion__statistics">
        {{ $t("facility", statistics.facility_amount) }}
        {{ $t("activity", statistics.activity_amount) }}
      </p>
      <p v-if="page !== User.members" class="text-h1 suggestion-text__subtitle">
        {{ $t(`suggestion_section.subtitle.${page}`) }}
      </p>
      <p class="suggestion__description text-h4">
        {{ $t(`suggestion_section.description.${page}`) }}
      </p>
      <BaseButton @click="showModalWrapper">
        {{ $t(wayToGetOfferText) }}
      </BaseButton>
      <BaseButton text @click="showAskQuestionModal">
        {{ $t("Ask Us a Question") }}
      </BaseButton>
    </div>
    <div class="suggestion-images">
      <slot name="images"></slot>
    </div>
    <LazyModalsAskQuestionFormModal v-if="mountAskQuestionModal" v-model:is-show-modal="isShowAskQuestionModal" />
  </section>
</template>

<script setup lang="ts">
import { CooperationTypes, User } from "~/types/entities";
import BaseButton from "~/components/button/BaseButton.vue";
import { SuggestionEvents } from "~/utils/analytics";

import { getStatistics } from "~/api/statisticsRequest";
import { useGetAnOfferFormModal } from "~/composables/modals/getAnOfferFormModal/useGetAnOfferFormModal";
import { useCountriesStore } from "~/stores/countries";

const props = defineProps({
  page: {
    type: String as PropType<User>,
    required: true,
  },
  isStatistics: {
    type: Boolean,
    default: false,
  },
});

const { gtag } = useGtag();
const { brand } = useRuntimeConfig().public;
const route = useRoute();
const localePath = useLocalePath();
const { showModal } = useGetAnOfferFormModal();
const { currentCountry } = storeToRefs(useCountriesStore());

const { statistics } = await getStatistics(currentCountry.value.code);

const mountAskQuestionModal = ref(false);
const isShowAskQuestionModal = ref<boolean>(false);

function showAskQuestionModal() {
  !mountAskQuestionModal.value && (mountAskQuestionModal.value = true);
  isShowAskQuestionModal.value = true;
  gtag("event", SuggestionEvents.askQuestionModal);
}

const cooperationType = computed(() => {
  if (route.fullPath === localePath("/companies")) return CooperationTypes.CONNECT_COMPANY;
  else if (route.fullPath === localePath("/partners")) return CooperationTypes.PARTNER;
  else return undefined;
});

const showModalWrapper = () => {
  gtag("event", SuggestionEvents.getOfferModal);
  showModal(true, cooperationType.value);
};

const wayToGetOfferText = computed(() => props.page === User.partners ? "Become a Partner" : "Get an Offer");

</script>
